/**
 * Copy text to clipboard with fallback for Document PiP windows.
 *
 * `navigator.clipboard.writeText()` requires the document to be focused,
 * which fails inside Document PiP windows. Falls back to the deprecated
 * `execCommand('copy')` which doesn't have this restriction.
 */
export async function copyToClipboard(text: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    // Fallback for unfocused documents (e.g. Document PiP windows)
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
    } finally {
      document.body.removeChild(textarea);
    }
  }
}
